// Reducer extracted from PlatformModule.js

import _ from "lodash";
import update from "immutability-helper";
import {
  SET_ORGANIZATION_CURRICULUM_PROGRAMS,
  SET_ORGANIZATION_PLANNER_ELEMENT_SETS,
  SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS,
  SET_CURRENT_CURRICULUM_PROGRAM,
  SET_CURRENT_PLANNER_ELEMENT_SETS,
  SET_ACADEMIC_YEAR_SELECTED,
  SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM,
  SET_SAMPLE_ORG_PORTAL_TYPE,
  SET_DEMO_ORG_CURRICULUM_ID,
  SET_ORGANIZATION_SUBJECT_LEVEL_TAGS,
  SET_CURRICULUM_SUBJECT_LEVEL_TAGS,
  SET_DEFAULT_NAME_SORT_PREFERENCE,
  SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE,
  SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE,
  SET_FULLSCREEN_LOADING,
  SET_UBD_ASSESSMENT_TYPES,
  SET_AI_MODULE_MARKETING_KEY,
  SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB,
  HOME_PAGE_WIDGET_PREFERENCES,
  SET_TODDLE_LIBRARY_VISIBILITY,
  SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS,
  SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS,
  SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS,
  SET_LEARNING_COURSE_ENABLED,
  SET_CUSTOM_ICONS,
  ADD_PROCESSED_CUSTOM_ICON,
  CONTEXTUAL_HELP_SIDEBAR_TOGGLE,
  SET_CONTEXTUAL_HELP_SEARCH_TEXT,
  SET_CONTEXTUAL_HELP_SELECTED_OPTION,
  RESET_CONTEXTUAL_HELP_SELECTED_OPTION,
} from "./PlatformConstants";

// Initial State
const initialState = {
  organizationCurriculumPrograms: [],
  academicCurriculumPrograms: [],
  accountCurriculumPrograms: [],
  schoolCurriculumPrograms: [],
  organizationPlannerElementSets: [],
  organizationPlannerElementSetLabels: [],
  currentCurriculumProgram: {
    id: null,
    type: null,
  },
  currentPlannerElementSets: {},
  curriculumPeriodDetails: [],
  organizationSubjectLevels: [],
  curriculumSubjectLevels: [],
  academicYearSelected: {
    id: null,
    startDate: null,
    endDate: null,
    isCurrentAcademicYear: true,
    isUpcomingAcademicYear: false,
    showPreviousYearMsg: true,
  },
  academicYearSelectedForCurrentCurriculumProgram: {
    id: null,
    startDate: null,
    endDate: null,
    isCurrentAcademicYear: true,
    isUpcomingAcademicYear: false,
  },
  sampleOrgPortalType: "",
  demoOrgCurriculumId: {
    IB_MYP: null,
    UBD: null,
  },
  defaultNameSortPreference: "FIRST_NAME",
  showFullScreenLoader: false,
  ubdAssessmentTypes: {},
  thirdPaneNotificationCenterActiveTab: null, // keep track of active tab in third pane notification center
  aiModuleMarketingKey: "",
  homePageWidgetPreferences: {},
  showToddleLibrary: true,
  isLearningCourseEnabled: false,
  customIcons: [], // Array of custom icons with SVG strings used in DS Icon Picker Wrapper
  contextualHelp: {
    isSidebarOpen: false,
    pageIdentifierTag: null,
    sidebarSearchText: "",
    searchedArticleId: null,
    sidebarTitle: "",
    aiQuestion: "",
    aiConversationId: null,
  },
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [SET_ORGANIZATION_CURRICULUM_PROGRAMS]: (state, action) => {
    return update(state, {
      organizationCurriculumPrograms: { $set: action.data },
    });
  },
  [SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB]: (state, action) => {
    return update(state, {
      thirdPaneNotificationCenterActiveTab: { $set: action.data },
    });
  },

  [SET_ORGANIZATION_PLANNER_ELEMENT_SETS]: (state, action) => {
    return update(state, {
      organizationPlannerElementSets: { $set: action.data },
    });
  },
  [SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS]: (state, action) => {
    return update(state, {
      organizationPlannerElementSetLabels: { $set: action.data },
    });
  },
  [SET_CURRENT_CURRICULUM_PROGRAM]: (state, action) => {
    return update(state, {
      currentCurriculumProgram: { $set: action.data },
    });
  },
  [SET_CURRENT_PLANNER_ELEMENT_SETS]: (state, action) => {
    return update(state, {
      currentPlannerElementSets: { $set: action.data },
    });
  },
  [SET_ORGANIZATION_SUBJECT_LEVEL_TAGS]: (state, action) => {
    return update(state, {
      organizationSubjectLevels: { $set: action.data },
    });
  },
  [SET_CURRICULUM_SUBJECT_LEVEL_TAGS]: (state, action) => {
    return update(state, {
      curriculumSubjectLevels: { $set: action.data },
    });
  },
  [SET_ACADEMIC_YEAR_SELECTED]: (state, action) => {
    const data = _.pick(action.data, [
      "id",
      "startDate",
      "endDate",
      "isCurrentAcademicYear",
      "isUpcomingAcademicYear",
      "showPreviousYearMsg",
    ]);
    return update(state, {
      academicYearSelected: {
        $set: { ...state.academicYearSelected, ...data },
      },
    });
  },
  [SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM]: (
    state,
    action
  ) => {
    const data = _.pick(action.data, [
      "id",
      "startDate",
      "endDate",
      "isCurrentAcademicYear",
      "isUpcomingAcademicYear",
    ]);
    return update(state, {
      currentCurriculumProgram: {
        academicYearSelected: {
          $set: data,
        },
      },
    });
  },
  [SET_SAMPLE_ORG_PORTAL_TYPE]: (state, action) => {
    return update(state, {
      sampleOrgPortalType: { $set: action.data },
    });
  },
  [SET_DEMO_ORG_CURRICULUM_ID]: (state, action) => {
    return update(state, {
      demoOrgCurriculumId: {
        $set: { ...state.demoOrgCurriculumId, ...action.data },
      },
    });
  },
  [SET_DEFAULT_NAME_SORT_PREFERENCE]: (state, action) => {
    return update(state, {
      defaultNameSortPreference: { $set: action.data },
    });
  },
  [SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE]: (state, action) => {
    return update(state, {
      defaultStudentNameOrderPreference: { $set: action.data },
    });
  },
  [SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE]: (state, action) => {
    return update(state, {
      defaultStudentIdentifierNamePreference: { $set: action.data },
    });
  },
  [SET_FULLSCREEN_LOADING]: (state, action) => {
    const showLoader = action.data;
    return update(state, {
      showFullScreenLoader: {
        $set: showLoader,
      },
    });
  },
  [SET_UBD_ASSESSMENT_TYPES]: (state, action) => {
    return update(state, {
      ubdAssessmentTypes: {
        $set: action.data,
      },
    });
  },
  [HOME_PAGE_WIDGET_PREFERENCES]: (state, action) => {
    return update(state, {
      homePageWidgetPreferences: {
        $set: {
          ...state.homePageWidgetPreferences,
          ...action.data,
        },
      },
    });
  },

  [SET_AI_MODULE_MARKETING_KEY]: (state, action) => {
    return update(state, {
      aiModuleMarketingKey: {
        $set: action.data,
      },
    });
  },
  [SET_TODDLE_LIBRARY_VISIBILITY]: (state, action) => {
    const showToddleLibrary = action.data;
    return update(state, {
      showToddleLibrary: {
        $set: showToddleLibrary,
      },
    });
  },
  [SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS]: (state, action) => {
    return update(state, {
      accountCurriculumPrograms: { $set: action.data },
    });
  },
  [SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS]: (state, action) => {
    return update(state, {
      schoolCurriculumPrograms: { $set: action.data },
    });
  },
  [SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS]: (state, action) => {
    return update(state, {
      academicCurriculumPrograms: { $set: action.data },
    });
  },
  [SET_LEARNING_COURSE_ENABLED]: (state, action) => {
    return update(state, {
      isLearningCourseEnabled: { $set: action.data },
    });
  },
  [SET_CUSTOM_ICONS]: (state, action) => {
    return update(state, {
      customIcons: { $set: action.data },
    });
  },
  [ADD_PROCESSED_CUSTOM_ICON]: (state, action) => {
    const existing = _.get(state, "customIcons", []);
    if (_.find(existing, { name: action.data.name })) return state;
    return update(state, {
      customIcons: { $set: [action.data, ...existing] },
    });
  },
  [CONTEXTUAL_HELP_SIDEBAR_TOGGLE]: (state, action) => {
    return update(state, {
      contextualHelp: {
        isSidebarOpen: { $set: action.data.isOpen },
        pageIdentifierTag: { $set: action.data.pageIdentifierTag },
      },
    });
  },
  [SET_CONTEXTUAL_HELP_SELECTED_OPTION]: (state, action) => {
    return update(state, {
      contextualHelp: {
        $set: { ...state.contextualHelp, ...action.data },
      },
    });
  },
  [RESET_CONTEXTUAL_HELP_SELECTED_OPTION]: (state, action) => {
    return update(state, {
      contextualHelp: {
        searchedArticleId: { $set: null },
        sidebarTitle: { $set: "" },
        aiQuestion: { $set: "" },
        aiConversationId: { $set: null },
      },
    });
  },
  [SET_CONTEXTUAL_HELP_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      contextualHelp: {
        sidebarSearchText: { $set: action.data },
      },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
